// extracted by mini-css-extract-plugin
export default {"root":"SlidingPanel_root__EV-TR","secondary":"SlidingPanel_secondary__n8vsP","show":"SlidingPanel_show__X7rZO","closeButton":"SlidingPanel_closeButton__yJr+P"};